import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getTicketActions = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.ticket.tabs.ticketactions'],
);

export const getTicketID = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.id'],
);

export const getTicketSeverity = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.severity'],
);

export const getTicketLoyaltySchema = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.loyaltyschema'],
);

export const getTicketStatus = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.status'],
);

export const getTicketCountry = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.tablecountry.country'],
);

export const getTicketCategory = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.category'],
);

export const getTicketAssignee = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.assignee'],
);

export const getTicketSearchBody = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.tickets.searchbody'],
);

export const getTicketSubject = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.subject'],
);

export const getTicketCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.creationdate'],
);

export const getTicketInitiator = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.initiator'],
);

export const getSortCustomer = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.customer'],
);

export const getSortId = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.id'],
);

export const getSortInitiationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.initiationdate'],
);

export const getSortInitiator = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.initiator'],
);

export const getSortLoyaltySchema = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.loyaltyschema'],
);

export const getSortSubject = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.subject'],
);

export const getSortTableTicketAssignee = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.tableticketassignee'],
);

export const getSortTableTicketCategory = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.tableticketcategory'],
);

export const getSortTableTicketSeverity = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.tableticketseverity'],
);

export const getSortTableTicketStatus = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.tickets.tableticketstatus'],
);

export const getCreateTicket = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.tickets.createticketmodal.header'],
);

export const getExecuteFlow = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.tickets.executeflow'],
);

export const getFlows = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.help.ticket.flows'],
);

export const getAssociateCustomer = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.associatecustomer'],
);

export const getClearCustomer = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.clearcustomer'],
);

export const getSchema = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema'],
);

export const getFullName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.customer.fullname'],
);

export const getBody = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.body'],
);

export const getCancelTicket = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.ticket.cancelticket'],
);

export const getTicket = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.create.ticket'],
);

export const getMemberNotFound = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.member.not.found'],
);

export const getEditTicketHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.tickets.edidticketmodal.header'],
);

export const getResolve = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.ticket.tabs.ticketactions.resolve'],
);

export const getMassInsertion = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.ticket.tabs.ticketactions.massinsertion'],
);

export const getResolveHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['tickets.actions.resolve.mainlabel'],
);

export const getResolveDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['tickets.actions.resolve.description'],
);

export const getUploadButton = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.unsubscribe.uploadbutton'],
);

export const getDragAndDrop = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.unsubscribe.draganddrop'],
);

export const getUploadedFile = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.unsubscribe.uploadedfile'],
);

export const getUploadedFileEmpty = createSelector(
  getLiteralsState,
  ({ literals }) => literals['member.utilities.unsubscribe.uploadedfileempty'],
);

export const getMassActionsEmail = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.massactions.email'],
);

export const getResolveBtn = createSelector(
  getLiteralsState,
  ({ literals }) => literals['tickets.actions.resolve.button'],
);

export const getNotificationEmail = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.massactions.notificationemail'],
);

export const getInsertTickets = createSelector(
  getLiteralsState,
  ({ literals }) => literals['tickets.actions.massinsert.insert'],
);
